import { Button } from "react-bootstrap";
import { ResumeState } from "../../blocs/resume/ResumeState";
import { Document, Page } from "react-pdf";
import CenterComponent from "../CenterComponent";

export default function ResumeBodyV1(downloadResume: () => void, state: ResumeState) {
    return <CenterComponent>
        <div style={{
            position: "fixed",
            bottom: 16,
            zIndex: 3,
            width: "100%",
        }}>
            <center>
                <Button
                    variant="dark"
                    onClick={downloadResume}
                    style={{ borderRadius: 90 }}
                >
                    👇Download
                </Button>
            </center>
        </div>
        <Document file={state.data!.fileUrl}>
            <Page
                pageNumber={1}
                scale={1.2} />
        </Document>
    </CenterComponent>;
}
